


















































import { Component, Vue } from "vue-property-decorator"
import BusinessListFilterForm from "./List/BusinessListFilterForm.vue"
import BusinessListFilterChip from "./List/BusinessListFilterChip.vue"
import { CREDIT_LEVELS } from "@/constants/business"

@Component({
  components: {
    BusinessListFilterForm,
    BusinessListFilterChip
  },
})
export default class BusinessList extends Vue {
  // Data
  options: BusinessListFilterOptions = { 
    page: 1, 
    itemsPerPage: 10, 
    query: null ,
    orderBy: null,
    orderByDirection: 'asc',
  }
  creditLevels = CREDIT_LEVELS

  headers = [
    { text: 'Name', value: 'name' },
    {
      text: 'Abn',
      value: 'abn',
      align: 'left',
      sortable: false,
    },
    { text: 'Credit Level', value: 'business_credit_level.level', align: 'center', sortable: false },
    { text: 'Actions', value: 'actions', align: 'left', sortable: false, width: '10%', cellClass: 'row-click-stop' },
  ]

  // Methods
  handleFetch() {
    return this.$store
      .dispatch("Business/fetchList", {
        params: {
          search_name: this.options.query,
          page: this.options.page,
          per_page: this.options.itemsPerPage,
          sort: this.options.orderByDirection == 'desc' ? '-' + this.options.orderBy : this.options.orderBy,
          },
      })
  }

  editBusiness(oid) {
    this.$router.push({
      name: "administrator-business-update",
      params: {
        businessOid: oid,
      },
    })
  }

  toRiskProfiles(oid) {
    this.$router.push({
      name: "administrator-risk-profile-list",
      params: {
        businessOid: oid,
      },
    })
  }

  businessCreditLevel(creditLevel) {
    return creditLevel ?? {
      name: 'Tier 1',
      level: 1,
      description: 'Pay As You Go Clients',
      amount_limit: 0
    }
  }

  handleClick(item) {
    this.editBusiness(item.object_id)
  }
}
